// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3p8Ei","name":"ConsentHeader_name__3aCnq","birthday":"ConsentHeader_birthday__1g5Vq","skeleton":"ConsentHeader_skeleton__6cKWW"};